import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';

class DailyAgingStress {

    static getDailyAgingStressV2(assetId, startDate, endDate) {
        const endpoint = formatEndpoint(endpoints.dailyAgingStress.getDailyAgingStressV2, { assetId, startDate, endDate });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }
}

export default DailyAgingStress;
